class SydfiskFaq extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.links = Array.from(this.querySelectorAll('[data-sf-faq-link]'));
    this.categories = Array.from(this.querySelectorAll('[data-sf-faq-category]'));
    this.items = Array.from(this.querySelectorAll('[data-sf-faq-item]'));

    this.items.forEach((item) => {
      item.addEventListener('toggle', () => this.onItemToggle(item));
    });

    this.links.forEach((link) => {
      link.addEventListener('click', (event) => this.onNavigationClick(event, link));
    });

    this.querySelectorAll('[data-sf-faq-contact]').forEach((link) => {
      link.addEventListener('click', () => {
        this.pushDataLayer('faq_contact_click', {
          faq_contact_type: link.dataset.sfFaqContact
        });
      });
    });

    this.addEventListener('shopify:block:select', (event) => {
      const item = event.target.closest('[data-sf-faq-item]');
      if (!item) return;

      const groupDetails = item.closest('.sf-faq__group-details');
      if (groupDetails) groupDetails.open = true;
      item.open = true;
    });

    this.observeCategories();
  }

  disconnectedCallback() {
    if (this.categoryObserver) this.categoryObserver.disconnect();
  }

  onItemToggle(item) {
    if (!item.open) return;

    const group = item.closest('[data-sf-faq-category]');
    if (group) {
      group.querySelectorAll('[data-sf-faq-item][open]').forEach((openItem) => {
        if (openItem !== item) openItem.open = false;
      });
    }

    this.pushDataLayer('faq_open', {
      faq_category: group ? group.dataset.sfFaqCategory : '',
      faq_question: item.dataset.faqQuestion || ''
    });
  }

  onNavigationClick(event, link) {
    const targetId = link.getAttribute('href');
    const target = targetId ? this.querySelector(targetId) : null;
    if (!target) return;

    event.preventDefault();

    const groupDetails = target.querySelector('.sf-faq__group-details');
    if (groupDetails) groupDetails.open = true;

    this.setActiveLink(link.dataset.sfFaqLink);

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const top = target.getBoundingClientRect().top + window.scrollY - 20;

    window.scrollTo({
      top,
      behavior: reduceMotion ? 'auto' : 'smooth'
    });

    if (history.replaceState) history.replaceState(null, '', targetId);
  }

  observeCategories() {
    if (!('IntersectionObserver' in window) || this.categories.length === 0) return;

    this.categoryObserver = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

        if (visible.length > 0) {
          this.setActiveLink(visible[0].target.dataset.sfFaqCategory);
        }
      },
      {
        rootMargin: '-18% 0px -62% 0px',
        threshold: [0, 0.15, 0.35, 0.6]
      }
    );

    this.categories.forEach((category) => this.categoryObserver.observe(category));
  }

  setActiveLink(category) {
    this.links.forEach((link) => {
      const isActive = link.dataset.sfFaqLink === category;
      link.classList.toggle('is-active', isActive);

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  pushDataLayer(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  }
}

if (!customElements.get('sydfisk-faq')) {
  customElements.define('sydfisk-faq', SydfiskFaq);
}